
import React from 'react';
import MainLayout from '../layouts/MainLayout';
import ContactForm from '../components/ContactForm';
import ContactFormHeader from '../components/contact/ContactFormHeader';
import FAQ from '../components/FAQ';
import Process from '../components/Process';
import InstagramFeed from '../components/InstagramFeed';
import AboutUs from '../components/AboutUs';
import { Helmet } from 'react-helmet';
import { useIsMobile } from '../hooks/use-mobile';

const ContactPage = () => {
  const isMobile = useIsMobile();
  
  return (
    <MainLayout>
      <Helmet>
        <title>Kontakt | Czułe Klisze</title>
        <meta name="description" content="Skontaktuj się z nami, aby omówić szczegóły Twojego wydarzenia. Czułe Klisze to profesjonalne studio fotograficzne i filmowe." />
        <meta property="og:title" content="Kontakt | Czułe Klisze" />
        <meta property="og:description" content="Skontaktuj się z nami, aby omówić szczegóły Twojego wydarzenia. Odpowiemy na wszystkie Twoje pytania." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://czuleklisze.pl/kontakt" />
        <link rel="canonical" href="https://czuleklisze.pl/kontakt" />
      </Helmet>
      
      <ContactFormHeader 
        title="Formularz Kontaktowy"
        subtitle="Poznajmy się lepiej. W odpowiedzi na formularz kontaktowy otrzymasz ofertę oraz dokładne szczegóły dotyczące naszej pracy."
      />
      
      <div id="contact">
        <ContactForm />
      </div>
      
      <AboutUs />
      
      <Process />
      
      <FAQ />
      
      <InstagramFeed />
    </MainLayout>
  );
};

export default ContactPage;
